import { useAppDispatch, useAppSelector } from 'js/store/hooks';
import { ImageCategory } from 'js/types';
import {
  setSearchInput as setSearchInputAction,
  clearSearchInput as clearSearchInputAction,
  setSelectedCategory,
  searchImages,
  resetSearch,
  navigateToCharacters
} from 'js/actionCreators/imageSearchActions';

const useHandleSearch = () => {
  const dispatch = useAppDispatch();
  const {
    searchInput,
    submittedSearchInput,
    isSearchInputSubmitted,
    searchType,
    selectedCategoryId,
    displayedStep,
    hideBackToCategories,
    activeSearchMode
  } = useAppSelector(state => state.imageSearch);

  const setSearchInput = (input: string) => {
    dispatch(setSearchInputAction(input));
  };

  const clearSearchInput = () => {
    dispatch(clearSearchInputAction());
  };

  const handleCategoryClick = (category: ImageCategory) => {
    dispatch(setSelectedCategory(category.id));
  };

  const handleClickToCategories = () => {
    dispatch(resetSearch());
  };

  const handleClickToCharacters = () => {
    dispatch(navigateToCharacters());
  };

  const handleSearch = () => {
    dispatch(searchImages());
  };

  return {
    searchInput,
    submittedSearchInput,
    isSearchInputSubmitted,
    searchType,
    selectedCategoryId,
    displayedStep,
    hideBackToCategories,
    activeSearchMode,
    setSearchInput,
    clearSearchInput,
    handleCategoryClick,
    handleClickToCategories,
    handleClickToCharacters,
    handleSearch
  };
};

export default useHandleSearch;
